import { useCurvas } from "./use-curvas";
import { CurvasView } from "./view-curvas";

export function CurvasScreen() {
  const vm = useCurvas();

  return <CurvasView {...vm} />;
}

export type * from "./types-curvas";
